import { Component, OnInit } from '@angular/core';
import { OfficeStatus } from '../../../../../../shared/office-status';
import { BrandService } from '../../../../../../services/brand.service';

@Component({
  selector: 'app-form-landing-footer',
  templateUrl: './form-landing-footer.component.html',
  styleUrls: ['./form-landing-footer.component.scss']
})
export class FormLandingFooterComponent implements OnInit {
  public officeStatus: OfficeStatus;
  public currentYear: number = 2023;

  constructor(public brandService: BrandService) { }

  ngOnInit() {
    let d = new Date();
    this.currentYear = d.getFullYear();
  }

}
